import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';

/**
 * Formato corporal: proporção entre ombros, cintura e quadril, em cinco
 * formatos (oval, retângulo, ampulheta, triângulo e triângulo invertido).
 * Referência: classificação por proporções de busto/ombros, cintura e quadril
 * usada em antropometria (Female Figure Identification Technique, FFIT, e
 * estudos de escaneamento 3D). Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/body_shape.php.
 */
// Um conjunto único de figuras para qualquer sexo, como a distribuição de
// gordura: o formato é lido pela proporção, não pelo corpo da figura.
const imageFor = (position) => `formato-corporal-${position}.png`;

const bodyShape = {
  key: 'body_shape',
  name: 'Formato corporal',
  description: 'Proporção entre ombros, cintura e quadril',
  details: 'Classifica a silhueta pela proporção entre ombros, cintura e quadril em cinco formatos: oval, retângulo, ampulheta, triângulo e triângulo invertido. Ajuda a ler onde o corpo concentra volume, orientar o plano alimentar e os procedimentos corporais e acompanhar a mudança de contorno ao longo do tratamento. Um clique marca o formato do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: AccessibilityNewOutlinedIcon,
  accent: 'purple',
  options: [
    { value: 'oval', label: 'Oval', image: imageFor(1), help: 'Cintura mais larga que ombros e quadril, com volume concentrado no abdome.' },
    { value: 'rectangle', label: 'Retângulo', image: imageFor(2), help: 'Ombros, cintura e quadril com larguras parecidas e cintura pouco marcada.' },
    { value: 'hourglass', label: 'Ampulheta', image: imageFor(3), help: 'Ombros e quadril largos e equilibrados, com cintura bem marcada.' },
    { value: 'triangle', label: 'Triângulo', image: imageFor(4), help: 'Quadril mais largo que os ombros, com volume na parte de baixo do corpo.' },
    { value: 'inverted_triangle', label: 'Triângulo invertido', image: imageFor(5), help: 'Ombros mais largos que o quadril, com volume na parte de cima do corpo.' },
  ],
};

export default bodyShape;
